import { render, staticRenderFns } from "./UpdatePassword.vue?vue&type=template&id=4e6bf2a6&scoped=true&"
import script from "./UpdatePassword.vue?vue&type=script&lang=js&"
export * from "./UpdatePassword.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePassword.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UpdatePassword.vue?vue&type=style&index=1&id=4e6bf2a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6bf2a6",
  null
  
)

export default component.exports